import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";

import Button from "components/common/Button";
import TalentAvatar from "components/Screens/Marketplace/Customer/Shortlist/TalentAvatar";
import type { ShortlistItem } from "components/Screens/Marketplace/Customer/types";
import "./Shortlist.scss";

interface Props {
  items: ShortlistItem[];
  seats: number;
  onFind: () => void;
  onPick: () => void;
  onClose: () => void;
}

/** Fewer than three shortlisted: ask whether Edge should find the others or the customer picks them. */
function RoomPopup({ items, seats, onFind, onPick, onClose }: Props) {
  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth slotProps={{ paper: { className: "sl-room-pop" } }}>
      <IconButton aria-label="Close" className="sl-pref-pop__x" onClick={onClose}>
        <CloseIcon />
      </IconButton>
      <div className="sl-room-pop__seats">
        {Array.from({ length: seats }, (_, i) =>
          items[i] ? (
            // eslint-disable-next-line no-underscore-dangle
            <TalentAvatar key={items[i].talent._id} talent={items[i].talent} size={48} />
          ) : (
            // eslint-disable-next-line react/no-array-index-key
            <span key={`open-${i}`} className="sl-room-pop__open" aria-label="Open seat">
              <AutoAwesomeOutlinedIcon fontSize="small" />
            </span>
          )
        )}
      </div>
      <h2 className="sl-pref-pop__title">You have room for more</h2>
      <p className="sl-pref-pop__sub">
        We set up one interview with three people. Would you like us to find the others, or would you rather pick them yourself?
      </p>
      <div className="sl-room-pop__actions">
        <Button variant="contained" size="large" label="Find them for me" onClick={onFind} />
        <Button variant="outlined" size="large" label="I'll pick myself" onClick={onPick} />
      </div>
    </Dialog>
  );
}

export default RoomPopup;
